module.exports = __webpack_public_path__ + "static/media/tokiwa10-2.a72b9872.jpg";